
export enum PropertyDetailsType {
    Directions = 'directions',
    Contact = 'contact',
    Info = 'info',
}

export enum PropertyDetailsSize {
    Small = 'small',
    Large = 'large',
}

export enum ContentType {
    FAQ = 'faq',
    MAIN = 'main',
    BUTTON = 'button'
}

export interface IPropertyProfileResult {
    data?: {
        profile: IPropertyProfile;
        properties: IPropertyResult[];
        pagination?: {
            page: number;
            limit: number;
            total: number;
            pages: number;
            hasNext: boolean;
            hasPrev: boolean;
        };
    };
    profile?: IPropertyProfile;
    properties?: IPropertyResult[];
}

export interface IPropertyResult {
    uid: string;
    profile: IPropertyProfile;

    name: string;
    description: string | IPropertyDetailsContent | IPropertyDetailsContent[] | string[];
    contact: string;

    photos: ImageResult[];
    photo?: ImageResult;
    details: IPropertyDetails[];
    faq: IPropertyFAQ[];

    geolocation: IGeoLocation;
    address: string;
    location: string;
    coordinates: ICoordinates;
    website?: string;
    languages?: string[];

}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function instanceOfProperty(object: any): object is IPropertyResult {
    return 'uid' in object;
}

export interface IPropertyProfile extends IBaseId {
    name: string;
    bio?: string;
    website?: string;
    photo?: {
        url: string;
        width: number;
        height: number;
        aspect_ratio?: number;
    },
    logo?: {
        url: string;
        width: number;
        height: number;
        aspect_ratio?: number;
    },
    languages?: string[];
}

export interface IBaseId extends IID {
    user_id?: string;
}
export interface IID {
    id: string;
}

export interface ImageResult {
    width: number;
    height: number;
    date: number;
    aspect_ratio?: number;
    url: string;
    lat?: number;
    long?: number;
}

export interface ICoordinates {
    lat: number;
    lon: number;
}

export interface IGeoLocation {
    type: 'Point' | 'Polygon' | 'LineString' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon';
    coordinates: number[];
}


export interface IPropertyDetails {
    name: string;
    type: PropertyDetailsType;
    size: PropertyDetailsSize;
    contents: string | IPropertyDetailsContent | IPropertyDetailsContent[] | string[];
    order: number;
}

export interface IPropertyDetailsContent {
    header: boolean;
    content: string | string[];
    copy: boolean;
    link?: string;
    type?: 'text' | 'link';

}

export interface IPropertyFAQ {
    question: string;
    answer: string | IPropertyDetailsContent | IPropertyDetailsContent[] | string[];
    order: number;
}

// New interfaces for Places API
export interface IPlace {
    id: string;
    location: IPlaceLocation;
    type: string;
    created_at: string;
    updated_at: string;
}

export interface IPlaceLocation {
    name: string;
    label: string;
    location: ICoordinates;
    contact?: IPlaceContact;
    address: IPlaceAddress;
    photos: IPlacePhoto[];
    provider?: {
        key: string;
    };
    distance?: {
        value: number;
    };
}

export interface IPlaceContact {
    phone?: string;
    website?: string;
}

export interface IPlaceAddress {
    house_number?: string;
    road?: string;
    town?: string;
    city?: string;
    state?: string;
    country: string;
    postcode?: string;
    country_code?: string;
}

export interface IPlacePhoto {
    id: string;
    url: string;
    width: number;
    height: number;
}

export interface IPlacesResponse {
    places: IPlace[];
    pagination: IPagination;
}

export interface IPagination {
    has_next: boolean;
    has_prev: boolean;
    next_cursor?: string;
    prev_cursor?: string;
    total: number;
}